
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"41","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M19.201 3.349h-6.697c-1.11 0-2.01-.9-2.01-2.01V0H5.136v1.117a13.977 13.977 0 001.26 5.82c1.453 3.2 3.47 6.11 5.956 8.593l1.134 1.134a15.798 15.798 0 012.964 4.113 6.007 6.007 0 01-5.372 8.693h-.354a12.458 12.458 0 00-8.87 3.673 6.131 6.131 0 00-1.359 6.622l.17.421h5.14v-.67c0-1.48 1.2-2.679 2.68-2.679H19.2c9.248 0 16.744-7.496 16.744-16.744S28.45 3.349 19.201 3.349zm0 32.149H8.485a4.025 4.025 0 00-3.963 3.349H1.593a4.793 4.793 0 011.209-4.756 11.128 11.128 0 017.922-3.282h.354a7.347 7.347 0 006.57-10.63 17.137 17.137 0 00-3.214-4.46l-1.135-1.135a27.86 27.86 0 01-5.685-8.201A12.631 12.631 0 016.476 1.34h2.679a3.353 3.353 0 003.349 3.348H19.2c8.508 0 15.405 6.897 15.405 15.405S27.709 35.498 19.2 35.498z"}}),_c('path',{attrs:{"d":"M31.257 18.084H21.134a2.01 2.01 0 00-1.881 2.715l.148.394a7.559 7.559 0 01-4.1 9.603l-1.233.528a1.478 1.478 0 00.582 2.834h4.551c7.765-.009 14.056-6.3 14.065-14.065 0-1.11-.9-2.01-2.009-2.01zM19.201 32.819h-4.55a.138.138 0 01-.055-.265l1.232-.528a8.9 8.9 0 004.827-11.304l-.148-.394a.67.67 0 01.627-.905h10.123c.37 0 .67.3.67.67-.008 7.025-5.701 12.717-12.726 12.726z"}}),_c('path',{attrs:{"d":"M27.908 20.763h1.34v1.34h-1.34zM26.569 26.121h1.34v1.34h-1.34zM22.55 28.8h1.34v1.34h-1.34zM22.55 22.772h1.34v1.34h-1.34z"}})])])
          )
        }
      }
    